
import Swiper, { Lazy, Navigation, Pagination } from "swiper";
import SinglePost from "./single-post";
import ScrollMagic from "scrollmagic";

const SingleNewMachinery = {
  init() {
    SingleNewMachinery.specification();
    SingleNewMachinery.reviewSlider();
    SinglePost.init();

    // Check if the screen size is greater than or equal to 1600px
    if ($(window).width() >= 1600) {
      SingleNewMachinery.stickBtn(".news-aside");
    }


    // Initialize ScrollMagic only if the screen size is greater than or equal to 900px
    if ($(window).width() >= 900) {
      SingleNewMachinery.stickBtn2(".btn.hero-btn");
    }
  },

  specification() {
    // Open/close single item.
    $(".specification-item__toggle").on("click", (e) => {
      const btn = $(e.currentTarget);

      const item = btn.closest(".specification-item");

      item.toggleClass("specification-item--open");

      item.find(".specification-item__content").slideToggle(400);
    });

    // Open/close all items at once.
    let allOpen = false;
    $(".specification-item__main-toggle").on("click", (e) => {

      // Toggles all open/close.
      if (!allOpen) {
        allOpen = true;
      } else {
        allOpen = false;
      }

      const btn = $(e.currentTarget);
      btn.toggleClass("specification-item__main-toggle--open");

      const items = $(".specification-item");

      // Open/close all items.
      items.each(function () {
        const item = $(this);

        if (allOpen && !item.hasClass("specification-item--open")) {
          item.addClass("specification-item--open");
          item.find(".specification-item__content").slideDown(400);
        } else if (!allOpen && item.hasClass("specification-item--open")) {
          item.removeClass("specification-item--open");
          item.find(".specification-item__content").slideUp(400);
        }

      });

    });
  },

  reviewSlider() {
    const reviewEl = $(".reviews");

    const slider = new Swiper(reviewEl.find(".review-slider")[0], {
      modules: [Lazy, Navigation, Pagination],
      loop: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: reviewEl.find(".swiper-button-next")[0],
        prevEl: reviewEl.find(".swiper-button-prev")[0],
      },
      pagination: {
        el: reviewEl.find(".swiper-pagination")[0],
        clickable: true,
        type: "bullets",
      },
    });
  },

  stickBtn(element) {
    // Check if the screen size is greater than or equal to 1600px before initializing ScrollMagic
    if ($(window).width() >= 1600) {
      let viewPortH = window.innerHeight;
      let scrollOffset = viewPortH / 2 - 80;

      const hasAdminBar = $("body").hasClass("admin-bar");
      if (hasAdminBar) {
        scrollOffset -= 32;
      }

      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
        triggerElement: element,
        offset: scrollOffset,
      })
        .setPin(element)
        .setClassToggle(element, "stuck")
        .addTo(controller);
    }
  },

  stickBtn2(element) {
    // Check if the screen size is greater than or equal to 900px before initializing ScrollMagic
    if ($(window).width() >= 900) {
      let viewPortH = window.innerHeight;
      let scrollOffset = viewPortH / 2 - 80;

      const hasAdminBar = $("body").hasClass("admin-bar");
      if (hasAdminBar) {
        scrollOffset -= 32;
      }

      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
        triggerElement: element,
        offset: scrollOffset,
      })
        .setPin(element)
        .setClassToggle(element, "stuck")
        .addTo(controller);
    }
  },
};

export default SingleNewMachinery;
